import '@arcgis/core/assets/esri/themes/light/main.css';
import '@esri/calcite-components/main.css';
// Required to register Calcite web component proxies (via @arcgis/core).
// Neither @arcgis/core nor @innovyze/inno-map call this themselves.
import { defineCustomElements } from '@esri/calcite-components/dist/loader';
import React from 'react';
import './App.css';

import { ApplicationWrapper, useIsFeatureEnabled } from '@innovyze/stylovyze';
import { getMiniPageRoutes, getMiniPageRoutesMulti } from '@Pages';
import { useIsRiskTemplatesEnabled } from '@Hooks/useIsRiskTemplatesEnabled';

// Must run before React renders — without this, Calcite elements are non-interactive.
defineCustomElements();

function App() {
	const isRiskTemplatesEnabled = useIsRiskTemplatesEnabled();
	const pages = useIsFeatureEnabled('info-360-asset-multiple-risk-models')
		? getMiniPageRoutesMulti(isRiskTemplatesEnabled)
		: getMiniPageRoutes(isRiskTemplatesEnabled);

	return <ApplicationWrapper pages={pages} />;
}

export default App;
